import React from 'react';

const VideoCall = () => {
  return (
    <div className="video-call-container">
      {/* <h2>Video Call</h2> */}
      <div className="videos">
        {/* Videos will go here */}
      </div>
    </div>
  );
};

export default VideoCall; 